import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=cb53c4c6&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb53c4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb53c4c6')) {
      api.createRecord('cb53c4c6', component.options)
    } else {
      api.reload('cb53c4c6', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=cb53c4c6&scoped=true&", function () {
      api.rerender('cb53c4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-274dllbdX03ZA/JS/comp/Voucher-Unit.vue"
export default component.exports